import PostAdd from '@mui/icons-material/PostAdd'
import { Button, IconButton, Tooltip } from '@mui/material'

import RestartFlowModal from 'components/Modals/RestartFlowModal'
import { useFlow } from 'utils/flow'
import { getRestartButtonLabel } from 'utils/restartButton'
import { useBoolean } from 'utils/hook'

import RedoIcon from './RedoIcon'

export default function StartOverButton(): JSX.Element {
  const [isModalOpen, openModal, closeModal] = useBoolean(false)
  const { data: flow } = useFlow()
  const labeledMode = flow?.restart_button_labeled === true
  const buttonLabel = getRestartButtonLabel(flow)
  const tooltipTitle = labeledMode ? 'Start a new claim' : 'Start flow again'

  return (
    <>
      {labeledMode ? (
        <Tooltip title={tooltipTitle}>
          <Button
            className="start-over-btn"
            variant="outlined"
            startIcon={<PostAdd />}
            onClick={openModal}
            aria-label="Start a new claim"
          >
            {buttonLabel}
          </Button>
        </Tooltip>
      ) : (
        <Tooltip title={tooltipTitle}>
          <IconButton className="start-over-btn" sx={{ display: 'inline-flex' }} onClick={openModal}>
            <RedoIcon />
          </IconButton>
        </Tooltip>
      )}
      {isModalOpen && (
        <RestartFlowModal open={isModalOpen} onClose={closeModal} labeledMode={labeledMode} />
      )}
    </>
  )
}
